module.exports = __webpack_public_path__ + "img/0013.92731bed.jpg";